import React, { Component } from 'react';
import {
  Text,
  Button,
  Status,
  Checkbox,
  Input as Inp,
  DatePicker,
  Loader
} from '../../Atoms';
import {
  Input,
  Upload,
  Table,
  Pagination,
  StepsProgressBar,
  Modal
} from '../../Molecules';
class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      img: null,
      page: 1,
      perPage: 1,
      date: null,
      check: false,
      value: ""
    };
  }

  handleFileChange = e => {
    this.setState({
      img: URL.createObjectURL(e.target.files[0])
    });
  };

  test = page => {
    this.setState({ page: page });
  };

  render() {
    return (
      <div style={{ height: "100%", overflowY: "auto", width: "100%" }}>
        <Loader type="page" width={200} height={200} />
        <Text text={this.state.value} />
        <br />
        <Button boxShadow={true} />
        <Checkbox checked={this.state.check} onClick={() => this.setState({ check: !this.state.check })} />
        <Inp />
        <br />
        <Input inputLabel="inputLabel" errorMsg="errorMsg" />
        <br />
        <Input inputLabel="inputLabel" errorMsg="errorMsg" />
        <br />
        <Input inputLabel="inputLabel" errorMsg="errorMsg" />
        <br />
        <Input inputLabel="inputLabel" errorMsg="errorMsg" />
        <br />
        <Input inputLabel="inputLabel" errorMsg="errorMsg" />
        <br />
        <Input inputLabel="inputLabel" errorMsg="errorMsg" />
        <br />
      </div>
    );
  }
}
export default User;
